import styled from "@emotion/styled";
import Chip from "component/chips/Chip";
import React, { useState } from "react";
import DisplayType from "utils/displayType";
import { useLanguage } from "i18n/LanguageContext";
import { ReactComponent as FoldDown } from "../../../assets/fold_down.svg";

interface Props {
  sectors: string[];
  selectedSectors: string[];
  onSelect: (sector: string) => void;
  onSelectAll: () => void;
}
const SectorList: React.FC<Props> = (props) => {
  const mode = DisplayType();
  const { t } = useLanguage();
  const [isFold, updateFold] = useState<boolean>(true);

  const isAllSelect = props.selectedSectors.length === 0;

  return (
    <Container isFold={isFold}>
      <span className="sector__list__label font-sub-title4">SECTOR</span>
      <div className="sector__list">
        <Chip
          isClickable
          isActive={isAllSelect}
          onClickChip={props.onSelectAll}
        >
          All
        </Chip>
        {props.sectors.map((item) => {
          return (
            <Chip
              key={item}
              isClickable
              isActive={props.selectedSectors.includes(item)}
              onClickChip={() => {
                props.onSelect(item);
              }}
            >
              {item}
            </Chip>
          );
        })}
      </div>
      {mode === "Mobile" && (
        <div
          className="fold__controler__container"
          onClick={() => updateFold((prevState) => !prevState)}
        >
          <span className="font-body4">
            {isFold ? t("portfolio", "expand") : t("portfolio", "collapse")}
          </span>
          <FoldDown className={`fold__icon ${isFold ? "" : "unfold"}`} />
        </div>
      )}
    </Container>
  );
};

const Container = styled.div<{ isFold: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: row;

  .sector__list__label {
    min-width: 104px;
    max-width: 104px;
    color: var(--black);
  }

  .sector__list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 10px;
  }

  .fold__controler__container {
    width: calc(100% + 48px);
    height: 40px;
    display: flex;
    transform: translateX(-24px);
    flex-direction: row;
    justify-content: center;
    align-items: center;
    background-color: var(--grey-00);
    color: var(--grey-40);
    padding-top: 1px;
    gap: 4px;
    .fold__icon {
      width: 16px;
      height: 16px;
      transform: rotate(0);
      transition: all 0.2s ease;
    }
    .fold__icon.unfold {
      transform: rotate(180deg);
    }
  }

  @media only screen and (max-width: 768px) {
    flex-direction: column;
    .sector__list__label {
      min-width: 100%;
      max-width: 100%;
    }
    .sector__list {
      padding-top: 20px;
      padding-bottom: 20px;
      flex-wrap: ${(props) => (props.isFold ? "nowrap" : "wrap")};
      overflow: scroll;
      ::-webkit-scrollbar {
        display: none;
      }
    }
  }
`;

export default SectorList;
